import { BaseActionWidget, RouterViewActionWidget, http, SPI, ViewType, Widget, ActionType, ActiveRecordsOperator, RowContext } from '@kunlun/dependencies';
import ChatHistoryDialogVue from './ChatHistoryDialog.vue';

interface ChatMessage {
  id?: number;
  senderType: string;
  messageContent: string;
  messageType: string;
  sendTime?: string;
}

interface SessionInfo {
  customerName?: string;
  sourceLabel?: string;
  statusLabel?: string;
  statusClass?: string;
  dateLabel?: string;
  messageCount?: number;
}

const MODULE_NAME = 'deliAriesCoreSeller';

/** 客服聊天历史查看 Widget */
@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.View,
    name: 'uiViewa1d56038e67b491ca4b3d89bf279ce76',
    model: 'deli.aries.seller.DeliAriesSellerChatSession',
    widget: 'ViewAction'
  })
)
export class ChatHistoryWidget extends RouterViewActionWidget {
  @Widget.Reactive()
  protected messages: ChatMessage[] = [];

  @Widget.Reactive()
  protected loading: boolean = false;

  @Widget.Reactive()
  protected sessionInfo: SessionInfo = {};

  @Widget.Reactive()
  protected dialogVisible: boolean = false;

  private sessionId: number | null = null;

  public initialize(props: any) {
    // 表格行内场景：从 slotContext 取当前行数据，否则 activeRecords 不是当前行
    const slotContext = props.slotContext as RowContext;
    if (slotContext) {
      props.activeRecords = ActiveRecordsOperator.repairRecords(slotContext.data);
    }
    super.initialize(props);
    this.setComponent(ChatHistoryDialogVue);
    return this;
  }

  /** 点击"查看详情"：加载数据并打开弹窗 */
  @Widget.Method()
  protected async openDialog() {
    // 点击时实时获取当前行，避免表格行复用同一实例导致 sessionId 错乱
    const record = (this as any).activeRecords?.[0];
    debugger;
    const sessionId = record?.id ? record.id : null;
    if (!sessionId) {
      console.warn('[ChatHistory] 未获取到当前行会话 ID', record);
      return;
    }
    this.sessionId = sessionId;
    await this.loadSessionHistory(sessionId);
  }

  /** 加载会话历史消息 */
  private async loadSessionHistory(sessionId: number) {
    this.loading = true;
    try {
      const gql = `
        query {
          deliAriesSellerChatSessionQuery {
            queryPage(
              page: { currentPage: 1, size: 1 }
              queryWrapper: { rsql: "id==${sessionId}" }
            ) {
              content {
                id
                sessionCode
                customerName
                sessionSource
                status
                sessionStartTime
                lastMessageTime
                messageCount
                messages {
                  id
                  senderType
                  messageContent
                  messageType
                  sendTime
                }
              }
            }
          }
        }
      `;
      const res = await http.query<any>(MODULE_NAME, gql);
      const data = res?.data?.deliAriesSellerChatSessionQuery?.queryPage?.content?.[0];

      if (data) {
        this.messages = data.messages || [];
        this.sessionInfo = this.buildSessionInfo(data);
      }
    } catch (e) {
      console.error('[ChatHistory] 加载会话历史失败', e);
    } finally {
      this.loading = false;
    }
  }

  /** 构建会话信息展示对象 */
  private buildSessionInfo(data: any): SessionInfo {
    const sourceMap: Record<string, string> = {
      PC_MALL: 'PC商城',
      MINI_PROGRAM: '小程序',
      APP: 'APP',
      WORKBENCH: '工作台'
    };
    const statusMap: Record<string, { label: string; cls: string }> = {
      ACTIVE: { label: '进行中', cls: 'status-active' },
      CLOSED: { label: '已关闭', cls: 'status-closed' },
      TRANSFERRED: { label: '已转人工', cls: 'status-transferred' }
    };
    const status = statusMap[data.status] || { label: data.status || '未知', cls: '' };

    let dateLabel = '';
    if (data.sessionStartTime) {
      const d = new Date(data.sessionStartTime);
      dateLabel = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    return {
      customerName: data.customerName || '未知用户',
      sourceLabel: sourceMap[data.sessionSource] || data.sessionSource || '',
      statusLabel: status.label,
      statusClass: status.cls,
      dateLabel,
      messageCount: data.messageCount || 0
    };
  }
}
